import React from "react"
import { Elements } from "@stripe/react-stripe-js"
// eslint-disable-next-line no-restricted-imports
import { Container } from "@carrotfertility/carotene" // please do not import from @carrotfertility/carotene after eslint rule added on 3/20/25
import CheckoutForm from "./CheckoutForm"
import { loadStripe } from "@stripe/stripe-js"
import Settings from "../../../utils/CarrotConfig"

type stripeCheckoutOptionsProps = {
  clientSecret: string
  appearance: Record<string, any>
}

type StripeCheckoutFormProps = {
  options: stripeCheckoutOptionsProps
  paymentIntentAmount: string
  paymentIntentCurrencyCode: string
}

function StripeCheckoutForm({
  options,
  paymentIntentCurrencyCode,
  paymentIntentAmount
}: StripeCheckoutFormProps): JSX.Element {
  const stripePromise = loadStripe(Settings.STRIPE_PUBLISHABLE_KEY)

  return (
    <Container maxWidth="684px">
      <Elements options={options} stripe={stripePromise}>
        <CheckoutForm paymentIntentAmount={paymentIntentAmount} paymentIntentCurrencyCode={paymentIntentCurrencyCode} />
      </Elements>
    </Container>
  )
}

export default StripeCheckoutForm
